import {AbstractService} from './AbstractService';
import {generateMetricsMeta} from 'services/utils/metricsMeta';


const BID_MANAGER_PROGRESS_METRICS_URL = '/api/projects/{0}/bidmanager/progressmetrics';


export class BidManagerProgressMetricsService extends AbstractService {

  async list (projectId) {
    const url = BID_MANAGER_PROGRESS_METRICS_URL.format(projectId);
    return this.client.get(url);
  }

  metricsMeta () {
    return [
      generateMetricsMeta({id: 'clicks', name: 'Clicks', shortName: null, type: 'integer', isGrowthPositive: true, shouldTranslateName: true}),
      generateMetricsMeta({id: 'cpc_fact', name: 'CPC', shortName: null, type: 'currency', isGrowthPositive: false, shouldTranslateName: false}),
      generateMetricsMeta({id: 'impressions', name: 'Impressions', shortName: null, type: 'integer', isGrowthPositive: true, shouldTranslateName: true}),
      generateMetricsMeta({id: 'cpm_fact', name: 'CPM', shortName: null, type: 'currency', isGrowthPositive: false, shouldTranslateName: false}),
      generateMetricsMeta({id: 'ctr', name: 'CTR', shortName: null, type: 'percent', isGrowthPositive: true, shouldTranslateName: false}),
      generateMetricsMeta({id: 'a_transactions', name: 'Ecommerce transactions', shortName: 'Transactions', type: 'integer', isGrowthPositive: true, shouldTranslateName: true}),
      generateMetricsMeta({id: 'a_cpo_fact', name: 'CPO', shortName: null, type: 'currency', isGrowthPositive: false, shouldTranslateName: false}),
      generateMetricsMeta({id: 'a_goal_completions', name: 'Goal completions', shortName: 'Completions', type: 'integer', isGrowthPositive: true, shouldTranslateName: true}),
      generateMetricsMeta({id: 'a_goal_cpa_fact', name: 'CPA', shortName: null, type: 'currency', isGrowthPositive: false, shouldTranslateName: false}),
      generateMetricsMeta({id: 'crr_fact', name: 'CRR', shortName: null, type: 'percent', isGrowthPositive: false, shouldTranslateName: true}),
      generateMetricsMeta({id: 'orders_total', name: 'Orders', shortName: null, type: 'integer', isGrowthPositive: true, shouldTranslateName: true}),
      generateMetricsMeta({id: 'roi', name: 'ROI', shortName: null, type: 'percent', isGrowthPositive: true, shouldTranslateName: false})
    ];
  }
}
